const coreWalletFeeTypesForSelection = [
	'EventBased',
	'Periodic'
].map(key => {
	return { id: key, name: key };
});

const coreWalletFeeContextsForSelection = [
	'CurrencyExchange',
	'PaymentCreateFunding',
	'PaymentCreateWithdrawal',
	'PaymentCreateIncoming',
	'PaymentCreateOutgoing',
	'PaymentCreateRefund',
	'PaymentFailFunding',
	'PaymentFailIncoming',
	'PurchaseConfirm',
	'ShopInvoicing',
	'ShopSettlement',
	'P2PTransactionSend',
	'P2PTransactionReceive'
].map(key => {
	return { id: key, name: key };
});

export {
	coreWalletFeeTypesForSelection,
	coreWalletFeeContextsForSelection
};
